/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAIBillingTypeFromJSON, ApiAIBillingTypeToJSON, } from './ApiAIBillingType';
import { ApiAIPromptStatusFromJSON, ApiAIPromptStatusToJSON, } from './ApiAIPromptStatus';
import { ApiAIPromptTypeFromJSON, ApiAIPromptTypeToJSON, } from './ApiAIPromptType';
export function ApiAIPromptFromJSON(json) {
    return ApiAIPromptFromJSONTyped(json, false);
}
export function ApiAIPromptFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'advanced': !exists(json, 'advanced') ? undefined : json['advanced'],
        'billingCost': !exists(json, 'billingCost') ? undefined : json['billingCost'],
        'billingType': !exists(json, 'billingType') ? undefined : ApiAIBillingTypeFromJSON(json['billingType']),
        'billingVersion': !exists(json, 'billingVersion') ? undefined : json['billingVersion'],
        'componentId': !exists(json, 'componentId') ? undefined : json['componentId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'error': !exists(json, 'error') ? undefined : json['error'],
        'errorCounter': !exists(json, 'errorCounter') ? undefined : json['errorCounter'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'inputTokens': !exists(json, 'inputTokens') ? undefined : json['inputTokens'],
        'logId': !exists(json, 'logId') ? undefined : json['logId'],
        'openaiConversationId': !exists(json, 'openaiConversationId') ? undefined : json['openaiConversationId'],
        'outputTokens': !exists(json, 'outputTokens') ? undefined : json['outputTokens'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'response': !exists(json, 'response') ? undefined : json['response'],
        'responseTimeSeconds': !exists(json, 'responseTimeSeconds') ? undefined : json['responseTimeSeconds'],
        'status': !exists(json, 'status') ? undefined : ApiAIPromptStatusFromJSON(json['status']),
        'stopReason': !exists(json, 'stopReason') ? undefined : json['stopReason'],
        'type': !exists(json, 'type') ? undefined : ApiAIPromptTypeFromJSON(json['type']),
        'url': !exists(json, 'url') ? undefined : json['url'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'userInput': !exists(json, 'userInput') ? undefined : json['userInput'],
    };
}
export function ApiAIPromptToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'advanced': value.advanced,
        'billingCost': value.billingCost,
        'billingType': ApiAIBillingTypeToJSON(value.billingType),
        'billingVersion': value.billingVersion,
        'componentId': value.componentId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'error': value.error,
        'errorCounter': value.errorCounter,
        'id': value.id,
        'inputTokens': value.inputTokens,
        'logId': value.logId,
        'openaiConversationId': value.openaiConversationId,
        'outputTokens': value.outputTokens,
        'projectId': value.projectId,
        'response': value.response,
        'responseTimeSeconds': value.responseTimeSeconds,
        'status': ApiAIPromptStatusToJSON(value.status),
        'stopReason': value.stopReason,
        'type': ApiAIPromptTypeToJSON(value.type),
        'url': value.url,
        'userId': value.userId,
        'userInput': value.userInput,
    };
}
